export default __webpack_public_path__ + "static/media/kiiro.02873a66.png";